import request from '@/utils/request'

// 组装中心成品出库及时率报表
export function apiGetTimelyDeliveryRateList (query) {
	return request({
		url: `/inv/invOnhandQuantities/timelyDeliveryRateList`,
		method: 'get',
		params: query
	})
}

// 导出列表
export function apiInvOnhandQuantitiesNewExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/timelyDeliveryRateExport',
    method: 'post',
    data: data
  })
}
